<h2 mat-dialog-title class="bold-header">Import PriceList Excel Preview</h2>
<div *ngIf="isValidating" class="validation-overlay d-flex flex-column justify-content-center align-items-center">
  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
    <span class="visually-hidden"></span>
  </div>
  <p class="mt-3 fs-5 text-primary">Validating data, please wait...</p>
</div>
<div *ngIf="isSaving" class="validation-overlay d-flex flex-column justify-content-center align-items-center">
  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
    <span class="visually-hidden"></span>
  </div>
  <p class="mt-3 fs-5 text-primary">Saving Price List data, please wait...</p>
</div>
<div class="mat-table-container position-relative">

  <table mat-table [dataSource]="validatedData" class="mat-elevation-z8">

    <!-- Dynamic Column Definitions -->
    <ng-container *ngFor="let header of previewHeaders" [matColumnDef]="header">
      <th mat-header-cell *matHeaderCellDef class="bold-header">{{ header }}</th>
      <td mat-cell *matCellDef="let row">
        <!-- Date Formatting -->
        <ng-container *ngIf="dateHeaders.includes(header) && isValidDate(row[header])">
          {{ row[header] | date: 'yyyy-MM-dd' }}
        </ng-container>
        <ng-container *ngIf="!dateHeaders.includes(header)">
          <div *ngIf="header === 'ValidationStatus'">
            <div class="d-flex flex-column gap-3">
              <ng-container *ngIf="row[header]?.length > 0; else noErrors">
                <div *ngFor="let err of row[header]; let i = index"
                  class="text-danger d-flex align-items-start gap-3 text-wrap">
                  <span>{{ i + 1 }}.</span>
                  <span>{{ err }}</span>
                </div>
              </ng-container>

              <ng-template #noErrors>
                <div class="text-success">✅ No errors for this condition.</div>
              </ng-template>
            </div>


          </div>
          <p *ngIf="header !== 'ValidationStatus'">
            {{ row[header] }}
          </p>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="previewHeaders"></tr>
    <tr mat-row *matRowDef="let row; columns: previewHeaders;"></tr>
  </table>

  <div class="action-buttons">
    <button mat-raised-button class="green-button" (click)="save()" [disabled]="!isSaveEnabled">Save</button>
    <button mat-raised-button color="primary" (click)="validate()" [disabled]="!hasNoErrors()">
      <mat-spinner *ngIf="isValidating"></mat-spinner>
      <span *ngIf="isValidating">Validating...</span>
      <span *ngIf="!isValidating">Validate</span>
    </button>
    <button mat-raised-button color="warn" (click)="closeModel()">Close</button>
  </div>
</div>